import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../../app/localization/localization";
import { RootStoreContext } from "../../../app/stores/rootStore";

const TriangleButton = () => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const { ZwibblerUseTriangleTool, isTriangleEnabled, isZoomed, ZwibblerEnableReadOnlyMode } =
    rootStore.zwibblerStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  const handleClick = () => {
    if(isTriangleEnabled)ZwibblerEnableReadOnlyMode();
    else ZwibblerUseTriangleTool();
  };

  return (
    <>
      <Button
        id="triangle"
        className={classNames(
          "w-100 px-1 pt-1 pb-1 toolbarButton transparentButton",
          isTriangleEnabled
            ? `${theme!.toolbarActiveIconColor}`
            : `${theme!.toolbarIconColor}`
        )}
        color=""
        disabled={isZoomed}
        onClick={() => handleClick()}
        style={{ position: "relative" }}
      >
        <i className="far fa-triangle iconToolbarButton"></i>

        <h6 className="textToolbarButton mb-0">
          {t("toolbar_triangle_button")}
        </h6>
      </Button>
    </>
  );
};

export default observer(TriangleButton);
